export default __webpack_public_path__ + "static/media/suit.c4295899.png";